export enum ApiStatus {
    Idle = 'idle',
    Loading = 'loading',
    Success = 'success',
    Failure = 'failure'
}

export enum DayOfWeek {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
}

export enum EquipmentTypeCode {
    VN = 'VN',
    FB = 'FB',
    RF = 'RF',
}

export enum Grade {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
}

export enum RecommendationType {
    MoveMoreFreight = 'move_more_freight',
    MoveLessFreight = 'move_less_freight',
    StartService = 'start_service',
    StopService = 'stop_service',
}

export enum TmsSources {
    TMW = 'TMW',
    ICC = 'ICC',
}

export enum ValueReferences {
    NA = 'N/A',
}
